import { render } from "./MultipleExternalLabBarcodes.vue?vue&type=template&id=731e58e2"
import script from "./MultipleExternalLabBarcodes.vue?vue&type=script&lang=js"
export * from "./MultipleExternalLabBarcodes.vue?vue&type=script&lang=js"

import "./MultipleExternalLabBarcodes.vue?vue&type=style&index=0&id=731e58e2&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/MultipleExternalLabBarcodes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "731e58e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('731e58e2', __exports__)) {
    console.log('reload')
    api.reload('731e58e2', __exports__)
  }
  
  module.hot.accept("./MultipleExternalLabBarcodes.vue?vue&type=template&id=731e58e2", () => {
    console.log('re-render')
    api.rerender('731e58e2', render)
  })

}


export default __exports__